import { InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import "allotment/dist/style.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { loginRequest, msalConfig } from "./authConfig";
import RequestInterceptor from "./components/common/RequestInterceptor";
import "./custom.css";
import "./custom.scss";
import { routes } from "./routes";

const msalInstance = new PublicClientApplication(msalConfig);
const container = document.getElementById("root");

/**
 * The Base App component
 */
const App = (): React.ReactElement => {
  const router = createBrowserRouter(routes);
  return <RouterProvider router={router} />;
};

App.displayName = "App";

if (container) {
  const root = createRoot(container);
  if (process.env.REACT_APP_STAGE === "local") {
    root.render(
      <StrictMode>
        <RequestInterceptor>
          <App />
        </RequestInterceptor>
      </StrictMode>,
    );
  } else {
    root.render(
      <MsalProvider instance={msalInstance}>
        <MsalAuthenticationTemplate
          interactionType={InteractionType.Redirect}
          authenticationRequest={loginRequest}
        >
          <RequestInterceptor>
            <App />
          </RequestInterceptor>
        </MsalAuthenticationTemplate>
      </MsalProvider>,
    );
  }
}
